import { createReducer, on } from '@ngrx/store';
import { setArticleListPageNumber, setArticleListItemsPerPage, setPollListPageNumber, setPollListItemsPerPage, setCategoryListPageNumber, setCategoryListItemsPerPage,setArticleListFilters,clearArticleListFilters } from '../actions/article-poll-category-management.action';

export interface ArticlePollCategoryState {
  // Article list
  pageNumberArticleList: number;
  itemsPerPageArticleList: number;
  filters: any;
  pageNumberPollList: number;
  itemsPerPagePollList: number;
  pageNumberCategoryList: number;
  itemsPerPageCategoryList: number;
}

export const initialState: ArticlePollCategoryState = {
  pageNumberArticleList: 1,
  itemsPerPageArticleList: 10,
  filters: {},
   pageNumberPollList: 1,
    itemsPerPagePollList: 10,
    pageNumberCategoryList: 1,
    itemsPerPageCategoryList: 10

};

export const articlePollCategoryManagementReducer = createReducer(
    initialState,
    on(setArticleListPageNumber, (state, { pageNumberArticleList }) => ({ ...state, pageNumberArticleList })),
    on(setArticleListItemsPerPage, (state, { itemsPerPageArticleList }) => ({ ...state, itemsPerPageArticleList })),
    on(setPollListPageNumber, (state, { pageNumberPollList }) => ({ ...state, pageNumberPollList })),
    on(setPollListItemsPerPage, (state, { itemsPerPagePollList }) => ({ ...state, itemsPerPagePollList })),
    on(setCategoryListPageNumber, (state, { pageNumberCategoryList }) => ({ ...state, pageNumberCategoryList })),
    on(setCategoryListItemsPerPage, (state, { itemsPerPageCategoryList }) => ({ ...state, itemsPerPageCategoryList })),


  // 🔹 Article list filters
  on(setArticleListFilters, (state, { filters }) => ({
    ...state,
    filters
  })),
  on(clearArticleListFilters, (state) => ({
    ...state,
    filters: {}
  }))
);
